<template>
  <div v-html="content"></div>
</template>
<script>
import content from "@/content/trauma.md";

export default {
  data: () => ({ content })
};
</script>
